// base styles
import borders from "assets/mavric-theme/base/borders";
import colors from "assets/mavric-theme/base/colors";

// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";
import linearGradient from "assets/mavric-theme/functions/linearGradient";

const { borderWidth, borderColor,  } = borders;
const { secondary, info, transparent, primary } = colors;

const checkbox = {
  styleOverrides: {
    root: {
      "& .MuiSvgIcon-root": {
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        width: pxToRem(20),
        height: pxToRem(20),
        color: transparent.main,
        border: `${borderWidth[1]} solid ${primary.focus}`,
        borderRadius: pxToRem(5.6),
      },

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-focusVisible": {
        border: `${borderWidth[2]} solid ${secondary.main} !important`,
      },
      '& .MuiButtonBase-root .MuiCheckbox-root .Mui-disabled': {color: primary.divider}
    },

    colorPrimary: {
      color: borderColor,

      "&.Mui-checked": {
        color: secondary.main,

        "& .MuiSvgIcon-root": {
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), 
          ${linearGradient(
            secondary.main,
            secondary.main
          )}`,
          borderColor: secondary.main,
        },

        '&.Mui-disabled': {
          color: primary.divider,
  
          "& .MuiSvgIcon-root": {
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), 
            ${linearGradient(
              primary.divider,
              primary.divider
            )}`,
            borderColor: primary.divider,
          },
        }
      },
      '&.Mui-disabled': {
        color: primary.divider,

        "& .MuiSvgIcon-root": {
          // backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), 
          // ${linearGradient(
          //   primary.divider,
          //   primary.divider
          // )}`,
          borderColor: primary.divider,
        },
      }
    },

    colorSecondary: {
      color: borderColor,

      "& .MuiSvgIcon-root": {
        color: secondary.focus,
        "&.Mui-checked": {
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), ${linearGradient(
            secondary.focus,
            secondary.focus
          )}`,
          borderColor: secondary.focus,
        },
      },
    },
  },
};

export default checkbox;
